import { useEffect, useState } from "react";
import { ICountry } from "../../utils/country/interfaces/ICountry";
import {
  getCitiesTwo,
  getCountriesTwo,
  getStatesTwo,
} from "../../utils/country/service/getInfoCountry";
import { IState } from "../../utils/country/interfaces/IStates";
import { ICity } from "../../utils/country/interfaces/ICity";

function useLocation() {
  const [listCountries, setListCountries] = useState<ICountry[]>([]);
  const [countrySelected, setCountrySelected] = useState("");

  const [listDepartments, setListDepartments] = useState<IState[]>([]);
  const [departmentSelected, setDepartmentSelected] = useState("");

  const [listCities, setListCities] = useState<ICity[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      let country = await getCountriesTwo();
      setListCountries(country);
    };

    fetchData();
  }, []);

  const handleSelectCountry = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCountrySelected(event.target.value);
    await getDepartmentsList(event.target.value);
  };

  const getDepartmentsList = async (country: string) => {
    if (country != "") {
      const fetchData = async () => {
        let states = [];
        states = await getStatesTwo(country);
        setListDepartments(states);
      };
      fetchData();
    }
  };

  const handleSelectDepartment = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDepartmentSelected(event.target.value);
    await getCitiesData(event.target.value);
  };

  const getCitiesData = async (department: string) => {
    if (department != "") {
      const fetchData = async () => {
        let cities = [];
        cities = await getCitiesTwo(
          countrySelected.toString(),
          department.toString()
        );
        setListCities(cities);
      };
      fetchData();
    }
  };

  return {
    handleSelectCountry,
    handleSelectDepartment,
    listCountries,
    listDepartments,
    listCities,
  };
}

export default useLocation;
